import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { clearToken, getToken } from "../../utils/auth";
import BranchesSection from "./BranchesSection";
import EquipmentSection from "./EquipmentSection";
import BeansSection from "./BeansSection";

const API = process.env.REACT_APP_API_URL || window.location.origin;

export default function AdminProducts() {
    const nav = useNavigate();
    const token = getToken();

    const [items, setItems] = useState([]);
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [file, setFile] = useState(null);
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");
    const [categories, setCategories] = useState([]);
    const [newCategory, setNewCategory] = useState("");
    const [categoryId, setCategoryId] = useState(""); // ürün eklerken seçilecek
    const [mobileOpen, setMobileOpen] = useState("product"); // "category" | "product"

    const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};

    const load = async () => {
        const r = await fetch(`${API}/api/products`);
        const data = await r.json();
        setItems(Array.isArray(data) ? data : []);
    };

    useEffect(() => {
        if (!token) nav("/admin");
        else {
            load();
            loadCategories();
        }
        // eslint-disable-next-line
    }, []);

    const logout = () => {
        clearToken();
        nav("/admin");
    };

    const loadCategories = async () => {
        const r = await fetch(`${API}/api/categories`);
        const data = await r.json();
        setCategories(Array.isArray(data) ? data : []);
    };

    const addCategory = async (e) => {
        e.preventDefault();
        setErr("");

        if (!newCategory.trim()) return setErr("Kategori adı zorunlu");

        const r = await fetch(`${API}/api/categories`, {
            method: "POST",
            headers: { "Content-Type": "application/json", ...authHeaders },
            body: JSON.stringify({ name: newCategory.trim() }),
        });

        const data = await r.json();
        if (!r.ok) return setErr(data?.error || "Kategori eklenemedi");

        setNewCategory("");
        await loadCategories();
    };

    const delCategory = async (id) => {
        if (!window.confirm("Kategoriyi silmek istiyor musun?")) return;

        const r = await fetch(`${API}/api/categories/${id}`, {
            method: "DELETE",
            headers: { ...authHeaders },
        });

        const data = await r.json().catch(() => ({}));

        if (r.status === 409) {
            setErr(data?.error || "Bu kategoride ürün var. Önce ürünleri kaldırın.");
            return;
        }
        if (!r.ok) {
            setErr(data?.error || "Kategori silinemedi");
            return;
        }

        await loadCategories();
    };
    const uploadImage = async () => {
        const fd = new FormData();
        fd.append("image", file);

        const r = await fetch(`${API}/api/upload`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${getToken()}`, // ✅ MUTLAKA
            },
            body: fd,
        });

        // JSON değilse önce text okuyup hata basmak çok işe yarar:
        const text = await r.text();
        let data;
        try {
            data = JSON.parse(text);
        } catch {
            throw new Error(text); // burada <!DOCTYPE... görürüz
        }

        if (!r.ok) throw new Error(data?.error || "Upload başarısız");
        return data.imageUrl;
    };

    const addProduct = async (e) => {
        e.preventDefault();
        setErr("");

        if (!name.trim()) return setErr("Ürün adı zorunlu");
        if (!categoryId) return setErr("Kategori seçmek zorunlu");
        try {
            setBusy(true);

            let imageUrl = null;
            if (file) {
                imageUrl = await uploadImage(); // sadece seçildiyse
            }

            const r = await fetch(`${API}/api/products`, {
                method: "POST",
                headers: { "Content-Type": "application/json", ...authHeaders },
                body: JSON.stringify({
                    name: name.trim(),
                    description: description.trim() ? description.trim() : null,
                    imageUrl,
                    categoryId: categoryId || null,
                }),
            });

            const data = await r.json();
            if (!r.ok) throw new Error(data?.error || "Ürün eklenemedi");

            setName("");
            setDescription("");
            setFile(null);
            setCategoryId("");
            await load();
        } catch (e2) {
            setErr(e2.message || "Hata");
        } finally {
            setBusy(false);
        }
    };

    const del = async (id) => {
        if (!window.confirm("Ürünü silmek istediğine emin misin?")) return;

        const r = await fetch(`${API}/api/products/${id}`, {
            method: "DELETE",
            headers: { ...authHeaders },
        });

        if (r.status === 401) {
            clearToken();
            nav("/admin");
            return;
        }

        await load();
    };

    return (
        <div className="adminLayout">
            {/* SOL: Formlar */}
            <div className="adminFormsGrid">
                {/* KATEGORİ */}
                <div className={`adminSection ${mobileOpen === "category" ? "isOpen" : ""}`}>
                    <button
                        className="adminSectionHeader"
                        type="button"
                        onClick={() => setMobileOpen(mobileOpen === "category" ? "" : "category")}
                    >
                        <span>Kategori Yönetimi</span>
                        <span className="adminChevron">{mobileOpen === "category" ? "–" : "+"}</span>
                    </button>

                    <div className="adminSectionBody">
                        {/* Senin mevcut Kategori Yönetimi kart içeriğini buraya koy */}
                        <div className="adminCard">
                            <h3 className="adminH3">Kategori Yönetimi</h3>

                            <form onSubmit={addCategory} className="adminForm">
                                <input
                                    className="adminInput"
                                    placeholder="Kategori adı"
                                    value={newCategory}
                                    onChange={(e) => setNewCategory(e.target.value)}
                                />
                                <button className="adminBtn" type="submit">
                                    Kategori Ekle
                                </button>
                            </form>

                            <div className="adminList" style={{ marginTop: 12 }}>
                                {categories.map((c) => (
                                    <div
                                        className="adminRow"
                                        key={c.id}
                                        style={{ gridTemplateColumns: "1fr auto" }}
                                    >
                                        <div className="adminName">{c.name}</div>
                                        <button className="adminDanger" onClick={() => delCategory(c.id)}>
                                            Sil
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* ÜRÜN EKLE */}
                <div className={`adminSection ${mobileOpen === "product" ? "isOpen" : ""}`}>
                    <button
                        className="adminSectionHeader"
                        type="button"
                        onClick={() => setMobileOpen(mobileOpen === "product" ? "" : "product")}
                    >
                        <span>Yeni Ürün Ekle</span>
                        <span className="adminChevron">{mobileOpen === "product" ? "–" : "+"}</span>
                    </button>

                    <div className="adminSectionBody">
                        {/* Senin mevcut Yeni Ürün Ekle kart içeriğini buraya koy */}
                        <div className="adminCard">
                            <h3 className="adminH3">Yeni Ürün Ekle</h3>

                            <form onSubmit={addProduct} className="adminForm">
                                <input
                                    className="adminInput"
                                    placeholder="Ürün adı"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />

                                <textarea
                                    className="adminTextarea"
                                    placeholder="Açıklama (opsiyonel)"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    rows={4}
                                />

                                {/* kategori select */}
                                <select
                                    className="adminInput"
                                    value={categoryId}
                                    onChange={(e) => setCategoryId(e.target.value)}
                                >
                                    <option value="">Kategori seç (zorunlu)</option>
                                    {categories.map((c) => (
                                        <option key={c.id} value={c.id}>
                                            {c.name}
                                        </option>
                                    ))}
                                </select>

                                <input
                                    className="adminInput"
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => setFile(e.target.files?.[0] || null)}
                                />

                                {err ? <div className="adminError">{err}</div> : null}

                                <button className="adminBtn" type="submit" disabled={busy}>
                                    {busy ? "Yükleniyor..." : "Ürünü Kaydet"}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {/* SAĞ: ÜRÜN LİSTESİ */}
            <div className="adminCard">
                <h3 className="adminH3">Ürünler</h3>

                <div className="adminList">
                    {items.map((p) => (
                        <div className="adminRow" key={p.id}>
                            <div className="adminThumb">
                                {p.imageUrl ? (
                                    <img src={`${API}${p.imageUrl}`} alt={p.name} />
                                ) : (
                                    <div className="menuThumbPlaceholder">{p.name?.slice(0, 1)?.toUpperCase()}</div>
                                )}
                            </div>

                            <div className="adminInfo">
                                <div className="adminName">{p.name}</div>
                                {p.description ? <div className="adminDesc">{p.description}</div> : null}
                            </div>

                            <div className="adminActions">
                                <div className="adminBadge">{p.category?.name || "Kategorisiz"}</div>
                                <button className="adminDanger" onClick={() => del(p.id)}>
                                    Sil
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="adminFullWidthSection" style={{gridColumn:"1 / -1",width:"100%", marginTop: 18 }}>
                <BranchesSection />
                <EquipmentSection />
                <BeansSection />
            </div>
        </div>
    );
}